export const getUrlFromFile = (file: File | Blob): string => URL.createObjectURL(file);
